import { render, staticRenderFns } from "./guangfu.vue?vue&type=template&id=37d06af6&scoped=true&"
import script from "./guangfu.vue?vue&type=script&lang=js&"
export * from "./guangfu.vue?vue&type=script&lang=js&"
import style0 from "./guangfu.vue?vue&type=style&index=0&lang=css&"
import style1 from "./guangfu.vue?vue&type=style&index=1&id=37d06af6&scoped=true&lang=css&"
import style2 from "./guangfu.vue?vue&type=style&index=2&id=37d06af6&scoped=true&lang=css&"
import style3 from "./guangfu.vue?vue&type=style&index=3&id=37d06af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d06af6",
  null
  
)

export default component.exports